import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const DPOHistoryReviewVisit = React.forwardRef((props: any, ref: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          style={{ display: "flex", marginBottom: "10px" }}>

          <div
            style={{ padding:15 }}>
            {props.languageUX === "en" ? "Date" : "Date"}
          </div>
          <div
            style={{padding: "5px"}}>
            { props.DateStart}
          </div>
          <div
            style={{ padding:15 }}>
            -
          </div>
          <div
            style={{padding: "5px"}}>
            { props.DateTo}
          </div>
          <Button
            className={props.patientId === null ? "disabled" : ""}
            color="blue"
            onClick={props.handleGetHistoryVisit}
            size="mini"
            style={{ margin: "7px 15px", }}>
            {props.languageUX === "en" ? "Search" : "ค้นหา"}
          </Button>
        </div>
        <div
          style={{ display: "flex", height: "100%", padding: "10px" }}>
          <div>
            {props.cardFilterDentistElement}
          </div>
          <div>
            {props.cardFilterClinicElement}
          </div>
          <Table
            NoDataComponent={() => null}
            columns={props.columnsHistoryVisit}
            data={props.historyReviewVisitData}
            defaultPageSize={10}
            getTrProps={props.handleOnFocusFindingsRowVisit}
            pageSize={5}
            showPagination={false}
            sortable={false}
            style={{height: props.tableHeight ?? "655px", width:"100%"}}>
          </Table>
        </div>
      </div>
    )
})

DPOHistoryReviewVisit.displayName = "DPOHistoryReviewVisit";
export default React.memo(DPOHistoryReviewVisit)

export const screenPropsDefault = {"diagnosis":"tooth cavity"}

/* Date Time : Tue Aug 20 2024 16:54:56 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", height: \"100%\", padding: \"10px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 7,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "() => null"
        },
        "columns": {
          "type": "code",
          "value": "props.columnsHistoryVisit"
        },
        "data": {
          "type": "code",
          "value": "props.historyReviewVisitData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "10"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.handleOnFocusFindingsRowVisit"
        },
        "pageSize": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: props.tableHeight ?? \"655px\", width:\"100%\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", marginBottom: \"10px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Date",
          "valueEN": "Date"
        },
        "style": {
          "type": "code",
          "value": "{ padding:15 }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": " props.DateStart"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "-"
        },
        "style": {
          "type": "code",
          "value": "{ padding:15 }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "code",
          "value": " props.DateTo"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"5px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "className": {
          "type": "code",
          "value": "props.patientId === null ? \"disabled\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleGetHistoryVisit"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"7px 15px\", }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterDentistElement"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.cardFilterClinicElement"
        }
      },
      "seq": 15,
      "void": false
    }
  ],
  "forwardRef": true,
  "height": 80,
  "isMounted": true,
  "memo": true,
  "name": "DPOHistoryReviewVisit",
  "project": "cudent",
  "screenPropsDefault": {
    "diagnosis": "tooth cavity"
  },
  "width": 80
}

*********************************************************************************** */
